import { SlingoFooterComponent } from "slingo/components/slingo-footer-component";

export class PYLFooterComponent extends SlingoFooterComponent {
    public showPotentialWin(numbers: number[], winValue: string): void {
        // don't wanna show these in this game
        this.clear();
    }
}
